<template>
  <Print v-if="isPrint" :board="board" :form="form" :header="header" />
  <div v-else>
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      :readonly="board.readonly"
      :types="['writer_name', 'phone', 'date']"
      :typeslabel="{
        writer_name: '작성자',
        phone: '작성자 전화번호',
        date: '작성일',
      }"
    />

    <div>
      <h5 class="my-4"><i class="dot"></i> Ⅰ. 건설업체 개요</h5>
      <div class="writeGridContainer">
        <div>
          <div>①사업장명</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.field.field_name }}</p>
          <field-selector v-else :readonly="board.readonly" v-model="form.field.id" @select="handleFieldSelect" :use-default-field="false" />
        </div>
        <div>
          <div>②법인등록번호 (③사업자등록번호)</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.사업자등록번호 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.사업자등록번호" />
        </div>
        <div>
          <div>대표자</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.대표자 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.대표자" />
        </div>

        <div>
          <div>④사업장관리번호</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.사업장관리번호 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.사업장관리번호" />
        </div>
        <div>
          <div>소재지</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.소재지 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.소재지" />
        </div>
        <div>
          <div>시공능력평가순위</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.시공능력평가순위 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.시공능력평가순위" />
        </div>
      </div>
    </div>

    <table-custom
      :board="board"
      :is-print="isPrint"
      title="Ⅱ. 전담 보건관리자 현황"
      :tableData="[
        { id: 'no', title: '연번', type: 'no', width: '80px' },
        { id: '현장명', title: '현장명', type: 'company', placeholder: '' },
        { id: '사업개시번호', title: '④사업개시번호', type: 'text', placeholder: '' },
        { id: '공사금액', title: '공사금액(VAT 포함)', type: 'number', placeholder: '' },
        { id: '성명', title: '성명', type: 'text', placeholder: '' },
        { id: '성별', title: '성별', type: 'radio', radioItems: [{ value: '남' }, { value: '여' }], contentTdStyle: { alignContent: 'center'} },
        { id: '선임기간', title: '⑤선임기간\n' + '(평가기간 내 근무일수)', type: 'number', placeholder: '' },
        { id: '정규직', title: '정규직(O,X)', type: 'radio', radioItems: [{ value: 'O' }, { value: 'X' }], contentTdStyle: { alignContent: 'center'} },
      ]"
      :mobile="['no', '현장명', '사업개시번호']"
      v-model="form.전담보건관리자현황"
      :separate-button-row="isMobile"
      class="mt-28px"
    >
      <template #customTr>
        <tr style="background: #f9f9f9 !important">
          <td></td>
          <td class="text-center"><p style="font-weight: 500; padding: 10px">합계</p></td>
          <td colspan="3" class="text-center">
            <p style="font-weight: 500; padding: 10px">⑥선임 의무 전담 보건관리자 수 : {{ form.전담보건관리자현황.length }} 명</p>
          </td>
          <td colspan="4" class="text-center">
            <p style="font-weight: 500; padding: 10px">⑦정규직 전담 보건관리자 수 : {{ 정규보건관리자 }} 명</p>
          </td>
        </tr>
      </template>
    </table-custom>

    <div class="etc-table">
      <h5 class="my-4"><i class="dot"></i> 보고인</h5>
      <name-with-signature-row label-name="사업주" :name.sync="form.sign1.name" :signature.sync="form.sign1.sign" />

      <table class="mt-8">
        <colgroup>
          <col width="230" />
          <col />
        </colgroup>
        <tr>
          <th>첨부서류</th>
          <td>
            전담 보건관리자 선임보고서 사본 1부.<br/>
            근로계약서 1부.
          </td>
        </tr>
      </table>
    </div>

    <div class="etc-table mt-8">
      <h5 class="my-4"><i class="dot"></i> 참고</h5>
      <table>
        <tr>
          <th>공지사항</th>
        </tr>
        <tr>
          <td>「건설업체의 산업재해예방활동 평가기준」 제13조의 규정에 따라 건설업체가 제출한 산업재해 예방활동 실적에 대한 공단의 확인 결과, 허위로 판정된 경우 해당 지표의 평가점수를 0점 처리함</td>
        </tr>
      </table>

      <table class="mt-4">
        <tr>
          <th>작성방법</th>
        </tr>
        <tr>
          <td>
            ① 사업장명: 도급인 사업장명을 적습니다.<br/>
            ② 법인등록번호: 법인 설립 시 등기소에서 부여하는 등기용 등록번호를 적습니다.<br/>
            ③ 사업자등록번호: 국세청에 등록된 도급인 사업장 사업자 등록번호를 적습니다.<br/>
            ④ 사업장관리번호(사업개시번호): 근로복지공단의 산업재해보상보험 가입 시 부여된 도급인 사업장 관리번호(사업개시번호)를 적습니다.<br/>
            ⑤ 선임기간: 고용노동부에 선임 신고된 날 ~ 종료일(예시 19.11.20.~20.10.5. 또는 19.11.20. ~)<br/>
            ⑥ 선임 의무 전담 안전관리자 수: 건설업체 소속 건설현장에서 평가기간 중 6개월 초과 근무한 전담 안전관리자 합산 수<br/>
            ⑦ 정규직 전담 안전관리자 수: 건설업체 소속 건설현장에서 평가기간 중 6개월 초과 근무한 정규직 전담 안전관리자 합산 수<br/>
          </td>
        </tr>
      </table>
    </div>

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-8" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import RadioGroup from "@/components/radio/RadioGroup.vue";
import TimeSelector from "@/components/selector/TimeSelector.vue";
import TableCustom from "@/components/TableCustom.vue";
import Print from "./Print.vue";
import TimeSelectorRang from "@/components/selector/TimeSelectorRang.vue";
import FieldSelector from "@/components/selector/FieldSelector.vue";
import NameWithSignatureRow from "@/components/NameWithSignatureRow.vue";

export default {
  components: {
    NameWithSignatureRow,
    FieldSelector,
    TimeSelectorRang,
    Print,
    TableCustom,
    TimeSelector,
    RadioGroup,
    FileUploadModule,
    FieldSelectModule,
    PhotoUploadGridModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
    header: Object,
  },
  async created() {
    this.checkMobile();
    window.addEventListener("resize", this.checkMobile);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkMobile);
  },
  data() {
    return {
      isMobile: false,
      showEmployeePopup: false,
      showMemberPopup: false,

      form: {
        stdInfo: {},
        photoList: [],
        fileList: [],

        field: {},
        사업자등록번호: "",
        대표자: "",
        사업장관리번호: "",
        소재지: "",
        시공능력평가순위: "",

        전담보건관리자현황: [],

        sign1: {
          name: "",
          sign: "",
        },
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  computed: {
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
    정규보건관리자() {
      return this.form.전담보건관리자현황.filter(item => item.정규직 === 'O').length;
    }
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth < 768;
    },
    handleFieldSelect(field) {
      this.form.field = field;
      if (field && field.id) {
        this.loadField(field.id);
      }
    },
    async loadField(fieldId) {
      await this.$store.dispatch("project/LOAD_FIELD", { fieldId });
      const info = this.$store.state.project.fieldInfo;

      this.form.대표자 = info.director_name || "";
      this.form.소재지 = info.address || "";
    },
  },
};
</script>

<style lang="scss" scoped>
.etc-table {
  table {
    table-layout: fixed;
    border-collapse: collapse;
    width: 100%;

    th,
    td {
      border: 1px solid #cdcdcd;
      font-size: 14px;
      padding: 14px;
    }
    th {
      background-color: #f9f9f9;
      font-weight: 500;
      text-align: center;
    }
    td {
      font-weight: 400;
      text-align: start;
    }
  }
}
</style>
